import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  ExportData: any;
  Time: any;
};

export enum ExportType {
  Csv = 'CSV'
}

export enum IngestionType {
  InHouse = 'IN_HOUSE',
  Takeaway = 'TAKEAWAY'
}

export type Item = {
  __typename?: 'Item';
  addonAmount: Scalars['Float'];
  amount: Scalars['Float'];
  count: Scalars['Int'];
  name: Scalars['String'];
  totalAmount: Scalars['Float'];
};

export type ItemResponse = {
  __typename?: 'ItemResponse';
  items: Array<Item>;
  sums: ItemSums;
};

export enum ItemStatsSortOption {
  AddonAmount = 'ADDON_AMOUNT',
  Amount = 'AMOUNT',
  Count = 'COUNT',
  Name = 'NAME',
  TotalAmount = 'TOTAL_AMOUNT'
}

export type ItemSums = {
  __typename?: 'ItemSums';
  addonAmount: Scalars['Float'];
  amount: Scalars['Float'];
  count: Scalars['Int'];
  totalAmount: Scalars['Float'];
};

export type Order = {
  __typename?: 'Order';
  amount: Scalars['Float'];
  date: Scalars['Time'];
  id: Scalars['String'];
  ingestion: IngestionType;
  mobile: Scalars['String'];
  orderNumber: Scalars['String'];
  paymentType: PaymentType;
  table: Scalars['String'];
  tip: Scalars['Float'];
};

export type OrderResponse = {
  __typename?: 'OrderResponse';
  count: Scalars['Int'];
  data: Array<Order>;
};

export enum OrderStatsSortOption {
  Amount = 'AMOUNT',
  Date = 'DATE',
  Ingestion = 'INGESTION',
  OrderNumber = 'ORDER_NUMBER',
  PaymentType = 'PAYMENT_TYPE',
  Table = 'TABLE',
  Tip = 'TIP'
}

export type OrderWithItem = {
  __typename?: 'OrderWithItem';
  amount: Scalars['Float'];
  comment: Scalars['String'];
  count: Scalars['Int'];
  date: Scalars['Time'];
  id: Scalars['String'];
  ingestion: IngestionType;
  mobile: Scalars['String'];
  name: Scalars['String'];
  orderNumber: Scalars['String'];
  paymentType: PaymentType;
  table: Scalars['String'];
  tip: Scalars['Float'];
};

export type OrderWithItemResponse = {
  __typename?: 'OrderWithItemResponse';
  count: Scalars['Int'];
  data: Array<OrderWithItem>;
};

export enum PaymentType {
  Cash = 'CASH',
  Creditcard = 'CREDITCARD',
  Invoice = 'INVOICE',
  OpenBill = 'OPEN_BILL',
  Other = 'OTHER',
  SwbCreditcard = 'SWB_CREDITCARD',
  SwbSwish = 'SWB_SWISH',
  Swish = 'SWISH',
  SwishBusiness = 'SWISH_BUSINESS'
}

export type Query = {
  __typename?: 'Query';
  exportItems: Scalars['ExportData'];
  exportOrders: Scalars['ExportData'];
  items: ItemResponse;
  itemsForOrder: Array<Item>;
  orders: OrderResponse;
  ordersWithItem: OrderWithItemResponse;
};


export type QueryExportItemsArgs = {
  endDate: Scalars['Time'];
  exportType: ExportType;
  sortBy?: InputMaybe<ItemStatsSortOption>;
  sortDirection?: InputMaybe<SortOrder>;
  startDate: Scalars['Time'];
};


export type QueryExportOrdersArgs = {
  endDate: Scalars['Time'];
  exportType: ExportType;
  sortBy?: InputMaybe<OrderStatsSortOption>;
  sortDirection?: InputMaybe<SortOrder>;
  startDate: Scalars['Time'];
};


export type QueryItemsArgs = {
  endDate: Scalars['Time'];
  sortBy?: InputMaybe<ItemStatsSortOption>;
  sortDirection?: InputMaybe<SortOrder>;
  startDate: Scalars['Time'];
};


export type QueryItemsForOrderArgs = {
  orderId: Scalars['String'];
};


export type QueryOrdersArgs = {
  count?: InputMaybe<Scalars['Int']>;
  endDate: Scalars['Time'];
  offset?: InputMaybe<Scalars['Int']>;
  sortBy?: InputMaybe<OrderStatsSortOption>;
  sortDirection?: InputMaybe<SortOrder>;
  startDate: Scalars['Time'];
};


export type QueryOrdersWithItemArgs = {
  count?: InputMaybe<Scalars['Int']>;
  endDate: Scalars['Time'];
  itemId: Scalars['ID'];
  offset?: InputMaybe<Scalars['Int']>;
  sortBy?: InputMaybe<OrderStatsSortOption>;
  sortDirection?: InputMaybe<SortOrder>;
  startDate: Scalars['Time'];
};

export enum SortOrder {
  Ascending = 'ASCENDING',
  Descending = 'DESCENDING'
}

export type ItemStatsExportQueryVariables = Exact<{
  exportType: ExportType;
  startDate: Scalars['Time'];
  endDate: Scalars['Time'];
  sortBy?: InputMaybe<ItemStatsSortOption>;
  sortDirection?: InputMaybe<SortOrder>;
}>;


export type ItemStatsExportQuery = { __typename?: 'Query', exportItems: any };

export type OrderStatsExportQueryVariables = Exact<{
  exportType: ExportType;
  startDate: Scalars['Time'];
  endDate: Scalars['Time'];
  sortBy?: InputMaybe<OrderStatsSortOption>;
  sortDirection?: InputMaybe<SortOrder>;
}>;


export type OrderStatsExportQuery = { __typename?: 'Query', exportOrders: any };

export type ItemStatsQueryVariables = Exact<{
  startDate: Scalars['Time'];
  endDate: Scalars['Time'];
  sortBy?: InputMaybe<ItemStatsSortOption>;
  sortDirection?: InputMaybe<SortOrder>;
}>;


export type ItemStatsQuery = { __typename?: 'Query', items: { __typename?: 'ItemResponse', sums: { __typename?: 'ItemSums', count: number, amount: number, addonAmount: number, totalAmount: number }, items: Array<{ __typename?: 'Item', name: string, count: number, amount: number, addonAmount: number, totalAmount: number }> } };

export type ItemsForOrderQueryVariables = Exact<{
  orderId: Scalars['String'];
}>;


export type ItemsForOrderQuery = { __typename?: 'Query', itemsForOrder: Array<{ __typename?: 'Item', name: string, count: number, amount: number, addonAmount: number, totalAmount: number }> };

export type OrderStatsQueryVariables = Exact<{
  startDate: Scalars['Time'];
  endDate: Scalars['Time'];
  count: Scalars['Int'];
  offset: Scalars['Int'];
  sortBy?: InputMaybe<OrderStatsSortOption>;
  sortDirection?: InputMaybe<SortOrder>;
}>;


export type OrderStatsQuery = { __typename?: 'Query', orders: { __typename?: 'OrderResponse', count: number, data: Array<{ __typename?: 'Order', id: string, orderNumber: string, date: any, mobile: string, amount: number, paymentType: PaymentType, ingestion: IngestionType, tip: number, table: string }> } };

export type OrdersWithItemQueryVariables = Exact<{
  startDate: Scalars['Time'];
  endDate: Scalars['Time'];
  itemId: Scalars['ID'];
}>;


export type OrdersWithItemQuery = { __typename?: 'Query', ordersWithItem: { __typename?: 'OrderWithItemResponse', count: number, data: Array<{ __typename?: 'OrderWithItem', id: string, orderNumber: string, date: any, amount: number, paymentType: PaymentType, ingestion: IngestionType, tip: number, table: string, mobile: string, name: string, count: number, comment: string }> } };


export const ItemStatsExportDocument = gql`
    query ItemStatsExport($exportType: ExportType!, $startDate: Time!, $endDate: Time!, $sortBy: ItemStatsSortOption, $sortDirection: SortOrder) {
  exportItems(
    exportType: $exportType
    startDate: $startDate
    endDate: $endDate
    sortBy: $sortBy
    sortDirection: $sortDirection
  )
}
    `;

/**
 * __useItemStatsExportQuery__
 *
 * To run a query within a React component, call `useItemStatsExportQuery` and pass it any options that fit your needs.
 * When your component renders, `useItemStatsExportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useItemStatsExportQuery({
 *   variables: {
 *      exportType: // value for 'exportType'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      sortBy: // value for 'sortBy'
 *      sortDirection: // value for 'sortDirection'
 *   },
 * });
 */
export function useItemStatsExportQuery(baseOptions: Apollo.QueryHookOptions<ItemStatsExportQuery, ItemStatsExportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ItemStatsExportQuery, ItemStatsExportQueryVariables>(ItemStatsExportDocument, options);
      }
export function useItemStatsExportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ItemStatsExportQuery, ItemStatsExportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ItemStatsExportQuery, ItemStatsExportQueryVariables>(ItemStatsExportDocument, options);
        }
export type ItemStatsExportQueryHookResult = ReturnType<typeof useItemStatsExportQuery>;
export type ItemStatsExportLazyQueryHookResult = ReturnType<typeof useItemStatsExportLazyQuery>;
export type ItemStatsExportQueryResult = Apollo.QueryResult<ItemStatsExportQuery, ItemStatsExportQueryVariables>;
export const OrderStatsExportDocument = gql`
    query OrderStatsExport($exportType: ExportType!, $startDate: Time!, $endDate: Time!, $sortBy: OrderStatsSortOption, $sortDirection: SortOrder) {
  exportOrders(
    exportType: $exportType
    startDate: $startDate
    endDate: $endDate
    sortBy: $sortBy
    sortDirection: $sortDirection
  )
}
    `;

/**
 * __useOrderStatsExportQuery__
 *
 * To run a query within a React component, call `useOrderStatsExportQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderStatsExportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderStatsExportQuery({
 *   variables: {
 *      exportType: // value for 'exportType'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      sortBy: // value for 'sortBy'
 *      sortDirection: // value for 'sortDirection'
 *   },
 * });
 */
export function useOrderStatsExportQuery(baseOptions: Apollo.QueryHookOptions<OrderStatsExportQuery, OrderStatsExportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrderStatsExportQuery, OrderStatsExportQueryVariables>(OrderStatsExportDocument, options);
      }
export function useOrderStatsExportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrderStatsExportQuery, OrderStatsExportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrderStatsExportQuery, OrderStatsExportQueryVariables>(OrderStatsExportDocument, options);
        }
export type OrderStatsExportQueryHookResult = ReturnType<typeof useOrderStatsExportQuery>;
export type OrderStatsExportLazyQueryHookResult = ReturnType<typeof useOrderStatsExportLazyQuery>;
export type OrderStatsExportQueryResult = Apollo.QueryResult<OrderStatsExportQuery, OrderStatsExportQueryVariables>;
export const ItemStatsDocument = gql`
    query ItemStats($startDate: Time!, $endDate: Time!, $sortBy: ItemStatsSortOption, $sortDirection: SortOrder) {
  items(
    startDate: $startDate
    endDate: $endDate
    sortBy: $sortBy
    sortDirection: $sortDirection
  ) {
    sums {
      count
      amount
      addonAmount
      totalAmount
    }
    items {
      name
      count
      amount
      addonAmount
      totalAmount
    }
  }
}
    `;

/**
 * __useItemStatsQuery__
 *
 * To run a query within a React component, call `useItemStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useItemStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useItemStatsQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      sortBy: // value for 'sortBy'
 *      sortDirection: // value for 'sortDirection'
 *   },
 * });
 */
export function useItemStatsQuery(baseOptions: Apollo.QueryHookOptions<ItemStatsQuery, ItemStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ItemStatsQuery, ItemStatsQueryVariables>(ItemStatsDocument, options);
      }
export function useItemStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ItemStatsQuery, ItemStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ItemStatsQuery, ItemStatsQueryVariables>(ItemStatsDocument, options);
        }
export type ItemStatsQueryHookResult = ReturnType<typeof useItemStatsQuery>;
export type ItemStatsLazyQueryHookResult = ReturnType<typeof useItemStatsLazyQuery>;
export type ItemStatsQueryResult = Apollo.QueryResult<ItemStatsQuery, ItemStatsQueryVariables>;
export const ItemsForOrderDocument = gql`
    query ItemsForOrder($orderId: String!) {
  itemsForOrder(orderId: $orderId) {
    name
    count
    amount
    addonAmount
    totalAmount
  }
}
    `;

/**
 * __useItemsForOrderQuery__
 *
 * To run a query within a React component, call `useItemsForOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useItemsForOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useItemsForOrderQuery({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useItemsForOrderQuery(baseOptions: Apollo.QueryHookOptions<ItemsForOrderQuery, ItemsForOrderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ItemsForOrderQuery, ItemsForOrderQueryVariables>(ItemsForOrderDocument, options);
      }
export function useItemsForOrderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ItemsForOrderQuery, ItemsForOrderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ItemsForOrderQuery, ItemsForOrderQueryVariables>(ItemsForOrderDocument, options);
        }
export type ItemsForOrderQueryHookResult = ReturnType<typeof useItemsForOrderQuery>;
export type ItemsForOrderLazyQueryHookResult = ReturnType<typeof useItemsForOrderLazyQuery>;
export type ItemsForOrderQueryResult = Apollo.QueryResult<ItemsForOrderQuery, ItemsForOrderQueryVariables>;
export const OrderStatsDocument = gql`
    query OrderStats($startDate: Time!, $endDate: Time!, $count: Int!, $offset: Int!, $sortBy: OrderStatsSortOption, $sortDirection: SortOrder) {
  orders(
    startDate: $startDate
    endDate: $endDate
    count: $count
    offset: $offset
    sortBy: $sortBy
    sortDirection: $sortDirection
  ) {
    count
    data {
      id
      orderNumber
      date
      mobile
      amount
      paymentType
      ingestion
      tip
      table
    }
  }
}
    `;

/**
 * __useOrderStatsQuery__
 *
 * To run a query within a React component, call `useOrderStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderStatsQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      count: // value for 'count'
 *      offset: // value for 'offset'
 *      sortBy: // value for 'sortBy'
 *      sortDirection: // value for 'sortDirection'
 *   },
 * });
 */
export function useOrderStatsQuery(baseOptions: Apollo.QueryHookOptions<OrderStatsQuery, OrderStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrderStatsQuery, OrderStatsQueryVariables>(OrderStatsDocument, options);
      }
export function useOrderStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrderStatsQuery, OrderStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrderStatsQuery, OrderStatsQueryVariables>(OrderStatsDocument, options);
        }
export type OrderStatsQueryHookResult = ReturnType<typeof useOrderStatsQuery>;
export type OrderStatsLazyQueryHookResult = ReturnType<typeof useOrderStatsLazyQuery>;
export type OrderStatsQueryResult = Apollo.QueryResult<OrderStatsQuery, OrderStatsQueryVariables>;
export const OrdersWithItemDocument = gql`
    query ordersWithItem($startDate: Time!, $endDate: Time!, $itemId: ID!) {
  ordersWithItem(startDate: $startDate, endDate: $endDate, itemId: $itemId) {
    count
    data {
      id
      orderNumber
      date
      amount
      paymentType
      ingestion
      tip
      table
      mobile
      name
      count
      comment
    }
  }
}
    `;

/**
 * __useOrdersWithItemQuery__
 *
 * To run a query within a React component, call `useOrdersWithItemQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrdersWithItemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrdersWithItemQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      itemId: // value for 'itemId'
 *   },
 * });
 */
export function useOrdersWithItemQuery(baseOptions: Apollo.QueryHookOptions<OrdersWithItemQuery, OrdersWithItemQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrdersWithItemQuery, OrdersWithItemQueryVariables>(OrdersWithItemDocument, options);
      }
export function useOrdersWithItemLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrdersWithItemQuery, OrdersWithItemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrdersWithItemQuery, OrdersWithItemQueryVariables>(OrdersWithItemDocument, options);
        }
export type OrdersWithItemQueryHookResult = ReturnType<typeof useOrdersWithItemQuery>;
export type OrdersWithItemLazyQueryHookResult = ReturnType<typeof useOrdersWithItemLazyQuery>;
export type OrdersWithItemQueryResult = Apollo.QueryResult<OrdersWithItemQuery, OrdersWithItemQueryVariables>;
export const namedOperations = {
  Query: {
    ItemStatsExport: 'ItemStatsExport',
    OrderStatsExport: 'OrderStatsExport',
    ItemStats: 'ItemStats',
    ItemsForOrder: 'ItemsForOrder',
    OrderStats: 'OrderStats',
    ordersWithItem: 'ordersWithItem'
  }
}